/** 
 *  Constants For WorkItem Attachment
 */
export enum WorkItemAttachmentConstants {

	/**
     * Constant for AddWorkItemAttachmentLink
     */
    ADD_WORKITEM_ATTACHMENT_LINK = "AddWorkItemAttachmentLink",

    /**
     * Constant for EditWorkItemAttachment
     */
    EDIT_WORKITEM_ATTACHMENT= "EditWorkItemAttachment",

    /**
     * Constant for DownloadWorkItemAttachment
     */
    DOWNLOAD_WORKITEM_ATTACHMENT= "DownloadWorkItemAttachment",

    /**
     * UploadDocument URL for API call
     */
    UPLOAD_DOCUMENT_URL = "WorkItemAttachment/UploadDocument"


}